module.exports = __webpack_public_path__ + "school/img/trainDetailBg.6915127a.jpg";